exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-container{\n    background-image: url('/assets/img/login-bg.png');\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    position: absolute;left: 0;right: 0;bottom: 0;top: 0;\n    /*height: 100%;width: 100%;*/\n}\n.icon-input-left{\n        float: left;\n        margin-left: 6px;\n        margin-top: 3px;\n        position: relative;\n        z-index: 2;\n        color: #FFFFFF;\n}\n    .icon-input-right{\n        float: right;\n        margin-right: 0px;\n        margin-top: 4px;\n        position: relative;\n        z-index: 2;\n        color: #FFFFFF;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/pages/login/login.component.css
// module id = ../../../../../src/app/pages/login/login.component.css
// module chunks = main